import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function InformationModal({
  open,
  title,
  body = "",
  onClose,
  buttonLabel = "OK",
  buttonAction,
  showBtn=true
}) {
  const [openModal, setOpenModal] = React.useState(open)

  React.useEffect(() => {
    setOpenModal(open)
  }, [open])

  const handleClose = () => {
    if(buttonAction){
      buttonAction()
    }

    setOpenModal(false)
    onClose();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        // onClose={handleClose}
        open={openModal}
        sx={{zIndex: 99999}}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} >
          {title}
        </DialogTitle>
        {showBtn && 
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        }
        
        <DialogContent dividers>
          {/* {body.toString()} */}
          <div dangerouslySetInnerHTML={{ __html: body.toString() }} />
        </DialogContent>
        <DialogActions>
          {showBtn && 
            <Button onClick={handleClose}>
              {buttonLabel}
            </Button>
          }
          
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}